import { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { applicantsColumns } from "./applicantsTableData";
import { getApplicants, deleteApplicant } from '../../api/applicantsService';
import {
  ActionContainer,
  AddCompany,
  DataGridContainer,
  DataGridWrapper,
} from "./style";
import { toast } from 'react-toastify';

import EventSelect from './EventSelect';
import SearchTorch from '../../components/search/SearchTorch';
import * as XLSX from 'xlsx';
import { useAuth } from "../../hooks/useAuth";

// import { db } from "../../firebase";
// import { useData } from "../../hooks/useData";

type ListType = "User" | "Product" | "Order" | "Events" | "Companies" | "Applicants";

const Applicants = () => {
  const location = useLocation();
  const { isAdmin } = useAuth();
  // change content on different path
  const type: ListType = "Applicants";
  const [applicants, setApplicants]: any = useState([]);
  const [eventId, setEventId] = useState('');
  useEffect(() => {
    const event_id = localStorage.getItem('applicants_event_id');
    setEventId(event_id || '');
    getApplicants(event_id || '').then((data: any) => {
      const new_data = data.filter((company: any) => company.event.deleted == "no");
      setApplicants(new_data);
    });
    return () => {

    }
  }, []);

  // Custom Hook for fathing data
  // by collection type from Firebase
  // const data = useData(type);

  // Handle deleting user from db
  const handleDelete = async (id: string) => {
    try {
      await deleteApplicant(id);
      const filtered_data: any = applicants.filter((item: any) => item.id !== id);
      setApplicants(filtered_data);
    } catch (err) {
      console.log(err);
    }
  };
  const getApplicantsByEvent = (event_id: any) => {
    localStorage.setItem('applicants_event_id', event_id);
    setEventId(event_id);
    getApplicants(event_id).then(results => {
      const new_data = results.filter((company: any) => company.event.deleted == "no");
      setApplicants(new_data);
    }).catch(err => {
      console.log(err.message);
    })
  }
  const onSearch = async (search_text: string) => {
    // console.log('search text', search_text);
    getApplicants(eventId).then(results => {
      const new_data = results.filter((company: any) => company.event.deleted == "no");
      if (search_text == '') {
        setApplicants(new_data);
      } else {
        const filteredCompanies = new_data.filter((company: any) =>
          company.name.toLowerCase().includes(search_text.toLowerCase())
        );
        setApplicants(filteredCompanies);
      }

    }).catch(err => {
      console.log(err.message);
    })
  }

  const exportExhibitors = async () => {

    // console.log('export', eventId);
    if(!eventId) {
      console.log("Please select event");
      toast.error('Please select event', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      return;
    }
    // Define the columns for the Excel sheet
    const headers = [
      "Event Name",
      "Booth No",
      "Company Name",
      "Event Guide Listing Phone",
      "Event Guide Listing Email",
      "Website url",
      "Event Guide Description",
      "Payment Status"
    ];

    // Prepare data for each order and its products
    const excelData = [headers];

    applicants.forEach((applicant: any) => {
      excelData.push([
        applicant.event?.full_name, 
        applicant.booth,
        applicant.company?.name,
        applicant.company?.guide_phone,
        applicant.company?.guide_email,
        applicant.company?.website_social_media,
        applicant.company?.description,
        applicant.payment,
      ]);
    });

    // Create a worksheet from the data
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Applicants");

    // Generate the Excel file
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Create a Blob for the Excel file
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    // Create a link to download the file with a dynamic name
    const dateTime = new Date().toISOString().replace(/[:.-]/g, '_').split('T').join('_');
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `Exhibitor_Event(${eventId})_Report_${dateTime}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  // Generic table fields
  const actions: GridColDef[] = [
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params: GridValueGetterParams) => {
        return (
          <ActionContainer>
            <Link
              to={`${location.pathname}/${params.row.id}`}
              state={{ ...params.row }}
              style={{ textDecoration: "none" }}
            >
              <button className="btn viewBtn">View</button>
            </Link>
            {isAdmin && (
            <button
              onClick={() => handleDelete(params.row.id)}
              className="btn deleteBtn"
            >
              Delete
            </button>
            )}
          </ActionContainer>
        );
      },
    },
  ];

  return (
    <Layout>
      <AddCompany>
        <h1 className="title">Exhibitors</h1>
        <EventSelect onSelect={getApplicantsByEvent} selected={eventId} />
        <SearchTorch onSearch={onSearch} />
        <div>
          {isAdmin && (
          <Link
            to={`${location.pathname}/new`}
            state={{ type }}
            style={{ textDecoration: "none" }}
          >
            <button className="add">Add Exhibitor</button>
          </Link>
          )}
          <Link
            to={`#`}
            state={{ type }}
            style={{ textDecoration: "none", margin: "5px" }}
            onClick={exportExhibitors}
          >
            <button className="add">Export Exhibitors</button>
          </Link>
        </div>
      </AddCompany>

      <DataGridWrapper>
        <DataGridContainer>
          <DataGrid
            style={{ backgroundColor: "white" }}
            rows={applicants}
            columns={applicantsColumns.concat(actions)}
            pageSize={10}
            rowsPerPageOptions={[10]}
          // checkboxSelection
          />
        </DataGridContainer>
      </DataGridWrapper>
    </Layout>
  );
};

export default Applicants;
